import React, { useState } from "react";
import { LuSquarePlus, LuSearch } from "react-icons/lu";
import Swal from "sweetalert2";
import AutomaticAgendaProspects from "./AutomaticAgendaProspects";

export default function ParamsProspects({ campaigns }) {
    const [activeMenu, setActiveMenu] = useState("respuestas");
    // Campaña seleccionada
    const [selectedCampaign, setSelectedCampaign] = useState(null);

    // Datos mockeados por campaña (solo pruebas)
    const fakeResponsesByCampaign = {
        1: [
            { id: 1, name: "No me interesa", checked: false },
            { id: 2, name: "Ya posee", checked: true },
        ],
        2: [
            { id: 3, name: "Me interesa", checked: false },
            { id: 4, name: "Llamar más tarde", checked: false },
            { id: 5, name: "Número incorrecto", checked: true },
        ],
        3: [
            { id: 6, name: "No contesta", checked: false },
            { id: 7, name: "Reagendar", checked: false },
        ],
    };

    // Respuestas de la campaña actual
    const responses = selectedCampaign
        ? fakeResponsesByCampaign[selectedCampaign.id] || []
        : [];

    const addCampain = () => {
        Swal.fire({
            title: "Agrega una nueva Campaña",
            input: "text",
            inputLabel: "Nombre de la campaña",
            inputPlaceholder: "Escribe el nombre de la campaña aquí...",
            showCancelButton: true,
            confirmButtonText: "Agregar",
            preConfirm: (campaignName) => {
                if (!campaignName) {
                    Swal.showValidationMessage("El nombre de la campaña no puede estar vacío.");
                }
                return campaignName;
            },
        }).then((result) => {
            if (result.isConfirmed) {
                const newCampaignName = result.value;

                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Campaña Agregada!",
                    text: `La campaña "${newCampaignName}" ha sido agregada con éxito.`,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    };

    if (activeMenu === "agendaAutomatica") {
        return (
            <div className="space-y-4">
                <div className="flex gap-2 border-b border-slate-200">
                    <button
                        type="button"
                        onClick={() => setActiveMenu("respuestas")}
                        className="border-b-2 border-transparent px-4 py-2 text-sm font-semibold text-slate-600 hover:text-custom-green-ccard-1"
                    >
                        Respuestas
                    </button>
                    <button
                        type="button"
                        onClick={() => setActiveMenu("agendaAutomatica")}
                        className="border-b-2 border-custom-green-ccard-1 px-4 py-2 text-sm font-semibold text-custom-green-ccard-1"
                    >
                        Agenda Automática
                    </button>
                </div>
                <AutomaticAgendaProspects />
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex gap-2 border-b border-slate-200">
                <button
                    type="button"
                    onClick={() => setActiveMenu("respuestas")}
                    className="border-b-2 border-custom-green-ccard-1 px-4 py-2 text-sm font-semibold text-custom-green-ccard-1"
                >
                    Respuestas
                </button>
                <button
                    type="button"
                    onClick={() => setActiveMenu("agendaAutomatica")}
                    className="border-b-2 border-transparent px-4 py-2 text-sm font-semibold text-slate-600 hover:text-custom-green-ccard-1"
                >
                    Agenda Automática
                </button>
            </div>

            <div className="flex gap-4">
            <div className="w-full lg:w-1/3">
                {/* TABLA 1 */}
                <div className=" bg-white border rounded-lg shadow-sm overflow-hidden">
                    <div className="p-4 border-b bg-custom-green-ccard-1/85 flex flex-col gap-3">
                        <div className="flex justify-between items-center text-white">
                            <h2 className="text-lg font-semibold">Lista de Campañas</h2>
                            <button onClick={addCampain}>
                                <LuSquarePlus className="text-2xl font-semibold" />
                            </button>
                        </div>
                        <div className="relative">
                            <LuSearch className="absolute left-2.5 top-2.5 w-4 text-gray-800" />
                            <input
                                type="text"
                                placeholder="Buscar..."
                                className="w-full pl-9 pr-4 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green-ccard-2 transition-all"
                            />
                        </div>
                    </div>

                    <div className="flex-1 overflow-y-auto">
                        <table className="w-full text-left text-sm">
                            <tbody className="divide-y">
                                {campaigns.map((item) => (
                                    <tr
                                        key={item.id}
                                        className="cursor-pointer transition-colors hover:bg-custom-green-ccard-1 hover:text-white"
                                        onClick={() => setSelectedCampaign(item)}
                                    >
                                        <td className="px-4 py-2">{item.prospectsName}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* TABLA 2 (OCULTA HASTA SELECCIONAR CAMPAÑA) */}
            {selectedCampaign && (
                <div className="w-full lg:w-1/3 bg-white border rounded-lg shadow-sm overflow-hidden">
                    <div className="p-4 border-b bg-custom-green-ccard-1/85 flex flex-col gap-3">
                        <div className="flex justify-between items-center text-white">
                            <h2 className="text-lg font-semibold">
                                Opciones de Respuesta – {selectedCampaign.prospectsName}
                            </h2>
                            <button>
                                <LuSquarePlus className="text-2xl font-semibold" />
                            </button>
                        </div>
                    </div>

                    <div className="flex-1 overflow-y-auto">
                        <table className="w-full text-left text-sm">
                            <tbody className="divide-y">
                                {responses.map((item) => (
                                    <tr key={item.id} className="cursor-pointer">
                                        <td className="px-4 py-2">{item.name}</td>
                                        <td className="px-4 py-2 text-right">
                                            <input
                                                type="checkbox"
                                                checked={item.checked}
                                                onChange={() =>
                                                    console.log(
                                                        `Toggle ${item.name} en campaña ${selectedCampaign.id}`
                                                    )
                                                }
                                                className="form-checkbox h-4 w-4 text-custom-green-ccard-2 rounded"
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            </div>
        </div>
    );
}
